<template>
  <el-row :class="getSidebarClass">
    <el-row class="post-sidebar__item">
      <period-range @setPeriod="setPeriod" :toDate="toDate" :fromDate="fromDate"/>
    </el-row>

    <el-row class="post-sidebar__item post-sidebar__item--row">
      <el-time-picker
        size="small"
        v-model="aSelectedStartTime"
        :placeholder="$t('post.sidebar.timePicker.start')">
      </el-time-picker>
      <span class="post-sidebar__time-range--separator"> - </span>
      <el-time-picker
        size="small"
        v-model="aSelectedEndTime"
        :placeholder="$t('post.sidebar.timePicker.end')">
      </el-time-picker>
    </el-row>

    <el-row class="post-sidebar__item">
      <span>Типы источников</span>
      <el-checkbox-group v-model="aSelectedSocial">
        <el-checkbox v-for="item in socialOptions" :label="item.label" :key="item.label"></el-checkbox>
      </el-checkbox-group>
      <el-row class="post-sidebar__item--row">
        <el-button type="primary" size="small" @click="selectAllSocial">Все</el-button>
        <el-button type="primary" size="small" @click="clearAllSocial">Очистить</el-button>
      </el-row>
    </el-row>

    <el-row class="post-sidebar__item">
      <span>Тональность публикаций</span>
      <el-select v-model="aSelectedTonal" size="small" placeholder="По тональности">
        <el-option
          v-for="item in tonalOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-row>

    <el-row class="post-sidebar__item">
      <span>Сортировка публикаций</span>
      <el-select v-model="aSelectedSort" value-key="name" size="small" placeholder="Сортировка">
        <el-option
          v-for="(item, index) in sortOptions"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-row>

    <el-row class="post-sidebar__item">
      <el-checkbox v-model="rePost">{{$t('post.sidebar.rePost')}}</el-checkbox>
    </el-row>

    <el-row class="post-sidebar__item">
      <el-button type="primary" @click="getPost">{{$t('post.sidebar.apply')}}</el-button>
    </el-row>

    <el-row class="post-sidebar__item">
      <el-button type="primary" @click="clearFilter" :disabled="!isFiltered">{{$t('post.sidebar.clear')}}</el-button>
    </el-row>

    <el-row class="post-sidebar__item">
      <el-button type="primary" @click="toggleDrawer">{{$t('post.sidebar.addPost')}}</el-button>
    </el-row>

  </el-row>
</template>

<script>
  // components
  import PeriodRange from "../../../../../../../components/postSidebarPeriodRange/PeriodRange";

  export default {
    name: 'PostSidebar',
    props: {
      selectedSocial: {
        type: Array
      },
      selectedTime: {
        type: Array
      },
      selectedStartTime: {
        type: Date
      },
      selectedEndTime: {
        type: Date
      },
      setDate: {
        type: Date
      },
      fromDate: {
        type: String
      },
      toDate: {
        type: String
      },
      socialOptions: {
        type: Array
      },
      sortOptions: {
        type: Array
      },
      selectedTonal: {
        type: Number
      },
      selectedSort: {
        Object
      },
      tonalOptions: {
        type: Array
      },
      reposts: {
        type: Boolean
      },
      isFiltered: {
        type: Boolean
      },
      showSidebar: {
        type: Boolean
      }
    },
    data() {
      return {
        localPeriodPayload: null,
      };
    },
    methods: {
      toggleDrawer() {
        this.$emit('toggleDrawer');
      },
      getPost() {
        this.$emit('loadPosts', this.localPeriodPayload);
      },
      selectAllSocial() {
        const value = this.socialOptions.map(item => item.label)
        this.$emit('setSelected', {postFix: 'Social', value});
      },
      clearAllSocial() {
        const value = [];
        this.$emit('setSelected', {postFix: 'Social', value});
      },
      reloadPosts() {
        this.$emit('reloadPosts');
      },
      clearFilter() {
        this.$emit('clearFilter');
      },
      setPeriod(value) {
        if (value) {
          const {period, payload} = value;
          this.localPeriodPayload = payload;
          this.$emit('setDate', {postFix: 'from', value: period[0]});
          this.$emit('setDate', {postFix: 'to', value: period[1]});
        }
      },
    },
    computed: {
      getSidebarClass() {
        return this.showSidebar ? 'post-sidebar post-sidebar--show' : 'post-sidebar';
      },
      getWrapClass() {
        return this.reposts ? 'repost-wrap active-wrap' : 'repost-wrap';
      },
      aSelectedSocial: {
        get() {
          return this.selectedSocial;
        },
        set(value) {
          this.$emit('setSelected', {postFix: 'Social', value});
        },
      },
      aSelectedTonal: {
        get() {
          return this.selectedTonal;
        },
        set(value) {
          this.$emit('setSelected', {postFix: 'Tonal', value});
        },
      },
      aSelectedTime: {
        get() {
          return this.selectedTime;
        },
        set(value) {
          this.$emit('setSelected', {postFix: 'Time', value});
        },
      },
      aSelectedStartTime: {
        get() {
          return this.selectedStartTime;
        },
        set(value) {
          console.log('aSelectedStartTime', value)
          this.$emit('setSelected', {postFix: 'StartTime', value});
        },
      },
      aSelectedEndTime: {
        get() {
          return this.selectedEndTime;
        },
        set(value) {
          console.log('aSelectedEndTime', value)
          this.$emit('setSelected', {postFix: 'EndTime', value});
        },
      },
      aSelectedSort: {
        get() {
          return this.selectedSort === null ? this.sortOptions[3].value : this.selectedSort;
        },
        set(value) {
          this.$emit('setSelected', {postFix: 'Sort', value});
        },
      },
      rePost: {
        get() {
          return this.reposts;
        },
        set(value) {
          this.$emit('setRePost', value);
        },
      }
    },
    mounted() {
      this.reloadPosts()
    },
    components: {
      PeriodRange,
    },
  };
</script>

<style>
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
  }

  .post-sidebar {
    position: relative;
    width: 350px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #EBEBEB;
    background-color: #fff;
    z-index: 1;
  }
  .post-sidebar .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
  .post-sidebar__item {
    margin-bottom: 15px;
  }
  .post-sidebar__item > span {
    opacity: 0.5;
    margin-bottom: 3px;
    display: block;
    font-size: 12px;
  }
  .post-sidebar__item .el-date-editor.el-input {
    width: 100%;
  }
  .post-sidebar__item .el-select {
    display: block;
  }
  .post-sidebar__item .el-select .el-input {
    width: 100%;
  }
  .post-sidebar__item .el-button {
    display: block;
    width: 100%;
  }
  .post-sidebar__item .el-date-editor--timerange.el-input__inner {
    width: 284px;
  }
  .post-sidebar__item:last-child {
    margin-bottom: 0;
  }
  .post-sidebar__item--row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
  }
  .post-sidebar__item .post-sidebar__item--row .el-button {
    width: calc(50% - 6px);
    flex-shrink: 0;
  }

  .post-sidebar__item .el-checkbox {
    width: 39%;
  }

  .post-sidebar__time-range--separator {
    margin: 0 6px;
  }
  .repost-wrap {
    padding: 8px;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
  }
  .active-wrap {
    border: 1px solid #409eff;
  }

  @media screen and (max-width: 480px) {
    .post-sidebar {
      display: none;
      position: fixed;
      left: 8px;
      top:0;
      width: 95%;
      padding-top: 45px;
      box-sizing: border-box;
      height: 100vh;
      z-index: 500;
    }
    .post-sidebar--show {
      display: block;
    }
  }
</style>
